import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import "../node_modules/font-awesome/css/font-awesome.min.css";
ReactDOM.render(<App />, document.getElementById("root"));
